'use client';

import {
  CaseStudyBody,
  CaseStudyResultsTable,
} from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { CustomerVideos } from '@/components/sections/customer-videos';
import Testimonials from '@/components/sections/testimonials';
import { useTranslation } from '@/lib/i18n/context';

const MollieCaseStudy = () => {
  const { t, isRTL } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="Mollie"
        title={
          t.customerStories[
            'How Mollie supports 250,000+ businesses across Europe'
          ]
        }
        subtitle={
          t.customerStories[
            "Open's AI agent handles 60%+ of support volume across email and chat. Merchants get instant answers in their language. Complex issues escalate with full context."
          ]
        }
        stats={[
          {
            value: isRTL ? '+٢٥٠ ألف' : '250K+',
            label: t.customerStories['Businesses served'],
          },
          {
            value: isRTL ? '٧٠٪' : '70%',
            label: t.customerStories['Automation rate'],
          },
          {
            value: isRTL ? '٢٤/٧' : '24/7',
            label: t.customerStories['In 8 languages'],
          },
        ]}
        videoSrc="/home/features/mollie-building.mp4"
        videoVariant="ambient"
      />

      <CaseStudyBody
        aside={{
          logoSrc: '/logos/logo-mollie.svg',
          logoAlt: 'Mollie',
          company: t.customerStories['mollie_company_description'],
          industry: t.customerStories['Financial Services / Payments'],
          websiteUrl: 'https://www.mollie.com',
          extras: [
            {
              label: t.customerStories['Company size'],
              value: t.customerStories['1000+ employees'],
            },
          ],
          keyResults: [
            t.customerStories['• 60%+ automation rate'],
            t.customerStories['• 24/7 support in 8 languages'],
            t.customerStories['• Sub-30 second response time'],
            t.customerStories['• Email and chat covered'],
          ],
        }}
      >
        <p>{t.customerStories['mollie_intro']}</p>

        <h2>{t.customerStories['mollie_scale_title']}</h2>
        <p>{t.customerStories['mollie_scale_p1']}</p>
        <p>{t.customerStories['mollie_scale_p2']}</p>

        <h2>{t.customerStories['mollie_what_open_does']}</h2>
        <p>{t.customerStories['mollie_open_p1']}</p>
        <p>{t.customerStories['mollie_open_p2']}</p>
        <p>{t.customerStories['mollie_open_p3']}</p>

        <h3>{t.customerStories['The Results']}</h3>
        <p>{t.customerStories['mollie_results_intro']}</p>

        <CaseStudyResultsTable
          metricLabel={t.customerStories['Metric']}
          impactLabel={t.customerStories['Impact']}
          rows={[
            {
              metric: t.customerStories['Automation rate'],
              impact: isRTL ? '٧٠٪' : '70%',
            },
            {
              metric: t.customerStories['Support coverage'],
              impact: t.customerStories['24/7 in 8 languages'],
            },
            {
              metric: t.customerStories['Response time'],
              impact: t.customerStories['Under 30 seconds'],
            },
            {
              metric: t.customerStories['Channels covered'],
              impact: t.customerStories['Email and chat'],
            },
          ]}
        />

        <p>{t.customerStories['mollie_results_p1']}</p>

        <h2>{t.customerStories['mollie_impact_title']}</h2>
        <p>{t.customerStories['mollie_impact_p1']}</p>
        <p>{t.customerStories['mollie_impact_p2']}</p>
        <p>{t.customerStories['mollie_impact_p3']}</p>
      </CaseStudyBody>

      <CustomerVideos />

      <Testimonials />
    </>
  );
};

export default MollieCaseStudy;
